import type { ReactNode } from "react";

/**
 * Row E as an inverted bar — the slide's verdict (see SlideGrid.ts).
 *
 * It rises out of the card's bottom edge, inset to the slide's own text column
 * and rounded on the two corners that are not the edge. That answers the
 * eyebrow tab at the opposite corner of the slide: identity bleeds off the
 * top-left, the conclusion bleeds off the bottom.
 *
 * Reserve it for a CONSEQUENCE — the thing that follows from the slide's
 * evidence. A line that merely restates the claim belongs above the rule, in
 * the statement band, not here.
 */
export function SlideVerdict({
  children,
  compact,
}: {
  children: ReactNode;
  /**
   * For a verdict that runs to two sentences rather than one line. The bar,
   * its fill and its bleed are unchanged — only the type steps down and stops
   * being centred, because a centred italic paragraph at display size is a
   * pull-quote, not a verdict. Prefer shortening the copy over reaching for
   * this.
   */
  compact?: boolean;
}) {
  return (
    <div className="-mb-4 mt-auto rounded-t-2xl bg-violet-700 px-6 py-4 md:-mb-8 md:px-8 md:py-5">
      <p
        className={
          compact
            ? "text-base font-medium leading-snug text-white md:text-xl"
            : "text-center text-lg font-bold italic leading-snug text-white md:text-3xl"
        }
      >
        {children}
      </p>
    </div>
  );
}
